var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "11",
        height: "15",
        viewBox: "0 0 11 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M0 5.53129C0 2.47655 2.46232 0 5.5 0C8.53768 0 11 2.47633 11 5.53107C11 8.58581 5.5 15 5.5 15C5.5 15 0 8.58603 0 5.53129ZM3.4375 5.4082C3.4375 6.51282 4.33288 7.4082 5.4375 7.4082C6.54242 7.4082 7.4375 6.51282 7.4375 5.4082C7.4375 4.30359 6.54242 3.4082 5.4375 3.4082C4.33288 3.4082 3.4375 4.30359 3.4375 5.4082Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }